<template>
  <div>
    <!-- Pestañas -->
    <!-- <div class="tabs">
      <button v-for="tab in tabs" :key="tab.id" :class="{ active: currentTab === tab.id }" @click="currentTab = tab.id">
        {{ tab.name }}
      </button>
    </div> -->

    <table class="styled-table">
      <thead>
        <tr>
          <th>Nombre del Contribuyente</th>
          <th>Autoridad que Notifica</th>
          <th>Tipo de Documento</th>
          <th>Archivos</th>
          <th>Fecha de Publicación</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="documento in paginatedDocumentos" :key="documento.id">
          <td style="text-align:center">{{ documento.propietario_documento }}</td>
          <td style="text-align:center">{{ documento.descripcion }}</td>
          <td style="text-align:justify">{{ documento.titulo }}</td>
          <td style="text-align:center;">
            <a v-if="documento.url_pdf" :href="documento.url_pdf" target="_blank" class="file-link">
              <i class="fas fa-file-pdf"></i> 
            </a>
            <a v-if="documento.url_word" :href="documento.url_word" target="_blank" class="file-link">
              <i class="fas fa-file-word"></i> 
            </a>
            <a v-if="documento.url_excel" :href="documento.url_excel" target="_blank" class="file-link">
              <i class="fas fa-file-excel"></i> 
            </a>
          </td>
          <td>{{ documento.fecha_actualizacion }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Paginador -->
<div class="pagination">
  <button @click="previousPage" :disabled="currentPage === 1">
    <i class="fas fa-chevron-left"></i> 
  </button>
  <span>Pag. {{ currentPage }} de {{ totalPages }}</span>
  <button @click="nextPage" :disabled="currentPage === totalPages">
     <i class="fas fa-chevron-right"></i>
  </button>
</div>
  </div>
</template>

<script>
export default {
  props: {
    documentos: {
      type: Array,
      required: true
    },
    // tabs: {
    //   type: Array,
    //   required: true
    // }
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 20,
      currentTab: 1 // Asumiendo que la primera pestaña es la activa por defecto
    };
  },
  computed: {
    paginatedDocumentos() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.documentos.slice(start, start + this.itemsPerPage);
    },
    totalPages() {
      return Math.ceil(this.documentos.length / this.itemsPerPage);
    }
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    }
  }
};
</script>

<style scoped>
.tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.tabs button {
  background-color: #007bff;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 0 5px;
  transition: background-color 0.3s;
}

.tabs button.active {
  background-color: #0056b3; /* Color más oscuro para la pestaña activa */
}

.tabs button:hover {
  background-color: #0056b3; /* Color al pasar el mouse */
}

.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.styled-table th{
  text-align:center;
}
.styled-table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
}

.styled-table th {
  background-color: #f2f2f2;
  color: #333;
}

.styled-table tr:nth-child(even) {
  background-color: #f9f9f9; /* Color para filas pares */
}

.styled-table tr:hover {
  background-color: #f1f1f1; /* Color al pasar el mouse sobre una fila */
}

.file-link {
  display: inline-flex;
  align-items: center;
  font-size:2rem;
  text-decoration: none;
  color: #e74c3c; /* Color del enlace */
}

.file-link i {
  margin-right: 5px; /* Espacio entre el icono y el texto */
}

.file-link:hover {
  text-decoration: underline; /* Subrayar al pasar el mouse */
}

.pagination {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination button {
  padding: 8px 12px;
  margin: 0 5px;
  border: none;
  background-color: #612;
  color: white;
  cursor: pointer;
  border-radius: 4px;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>
